import React from 'react';
import { useSelector } from 'react-redux';
import BannerTopComponent from '../bannerTopComponent/BannerTopComponent';
import conffetiBaanerRi from '../../../../../../assets/FinalStage/conffetiBaanerRi.gif';
import classes from './FinalBannerAfterAdvanced.module.css';

const FinalBannerAfterAdvanced = () => {

  const { texts } = useSelector((state) => state.translate);

  return (
    <BannerTopComponent title={texts.finalBannerTitle} colorBackground="#070A59">
      <div className={classes.bannerWrapper}>
        <div className={classes.bannerBottomContent}>
          <div className={classes.bannerBottomContentLeft}>
            <img src={conffetiBaanerRi} alt="" className={classes.confettiBannerRi} aria-hidden />
            <div className={classes.bannerBottomContentTitle}>
              <p className={classes.yourSchool}>{texts.yourSchool}</p>
              <p className={classes.thesAreTheFinalists}>{texts.thesAreTheFinalists}</p>
            </div>
          </div>
        </div>
      </div>
    </BannerTopComponent>
  );
};

export default FinalBannerAfterAdvanced;
